import React, { createContext, useState, useEffect } from 'react';
import { encrypted } from '../utils/Utility';
export const ThemeContext = createContext();
export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedMode = encrypted.getDecryptedItem("themeMode");
    return savedMode === "dark";
  });
  const toggleDarkMode = () => {
    setIsDarkMode((prevMode) => !prevMode);
  };
  useEffect(() => {
    if (isDarkMode) {
      document.body.classList.add("dark-mode");
      encrypted.setEncryptedItem("themeMode", "dark");
    } else {
      document.body.classList.remove("dark-mode");
      encrypted.setEncryptedItem("themeMode", "light");
    }
  }, [isDarkMode]);
  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleDarkMode }}>
      {children}
    </ThemeContext.Provider>
  );
};